import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
ReactDOM.createRoot(document.getElementById("root")).render(
   <HashRouter>
  <Provider store={store}>
   
    <ThemeProvider theme={theme}>
      <App />
      </ThemeProvider>
    
  </Provider>
  </HashRouter>
);
